module.exports = __webpack_public_path__ + "img/安徽先锋网电子政务后台管理.901f3849.jpg";